import * as actions from "../actionTypes/dynamicPricingActionTypes";

export const setDynamicPricingLoader = (_data: boolean) => {
    return {
        type: actions.SET_DYNAMIC_PRICING_LOADER,
        payload: _data
    };
};

export const getDynamicPricingList = (_data: string, _callback: any) => {
    return {
        type: actions.GET_DYNAMIC_PRICING_LIST,
        payload: _data,
        callback: _callback
    };
};

export const setDynamicPricingList = (_data: any) => {
    return {
        type: actions.SET_DYNAMIC_PRICING_LIST,
        payload: _data
    };
};

export const getDynamicPricingById = (_data: string, _callback: any) => {
    return {
        type: actions.GET_DYNAMIC_PRICING_BY_ID,
        payload: _data,
        callback: _callback
    };
};

export const setDynamicPricingDetails = (_data: any) => {
    return {
        type: actions.SET_DYNAMIC_PRICING_DETAILS,
        payload: _data
    };
};

export const createDynamicPricing = (_data: any, _callback: any) => {
    return {
        type: actions.CREATE_DYNAMIC_PRICING,
        payload: _data,
        callback: _callback
    };
};

export const updateDynamicPricing = (_data: any, _callback: any) => {
    return {
        type: actions.UPDATE_DYNAMIC_PRICING,
        payload: _data,
        callback: _callback
    };
};

export const deleteDynamicPricing = (_data: string, _callback: any) => {
    return {
        type: actions.DELETE_DYNAMIC_PRICING,
        payload: _data,
        callback: _callback
    };
};

export const getDynamicPricingFilters = (_data: any, _callback: any) => {
    return {
        type: actions.GET_DYNAMIC_PRICING_FILTERS,
        payload: _data,
        callback: _callback
    };
};

export const setDynamicPricingFilters = (_data: any) => {
    return {
        type: actions.SET_DYNAMIC_PRICING_FILTERS,
        payload: _data
    };
};

export const searchDynamicPricing = (_data: any, _callback: any) => {
    return {
        type: actions.SEARCH_DYNAMIC_PRICING,
        payload: _data,
        callback: _callback
    };
};

export const bulkUploadDynamicPricing = (_data: FormData, _callback: any) => {
    return {
        type: actions.BULK_UPLOAD_DYNAMIC_PRICING,
        payload: _data,
        callback: _callback
    };
};

export const syncDpMeta = (_callback: any) => {
    return {
        type: actions.SYNC_DP_META,
        callback: _callback
    };
};
